import React, { useState, useEffect } from 'react';
import './FloatingButtons.css'; // Importer le fichier CSS

function FloatingButtons() {
  const [showScrollToTop, setShowScrollToTop] = useState(false);
  // Ajout d'un état pour gérer l'ouverture/fermeture du numéro de téléphone
  const [isPhoneNumberExpanded, setIsPhoneNumberExpanded] = useState(false);

  // Utilisation de l'information sauvegardée pour le numéro de téléphone
  const phoneNumber = "05 61 88 75 78";

  // Gère l'affichage du bouton "Retour en haut"
  const handleScroll = () => {
    if (window.scrollY > 300) { // Affiche le bouton après avoir scrollé de 300px
      setShowScrollToTop(true);
    } else {
      setShowScrollToTop(false);
    }
  };

  // Fait défiler la page vers le haut
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth' // Pour un défilement doux
    });
  };

  // Gère le clic sur le bouton du téléphone
  const handlePhoneClick = (event) => {
    // Empêche le comportement par défaut du lien (naviguer vers `tel:`) sur ordinateur
    // Uniquement si le numéro n'est pas déjà affiché et que nous sommes sur un grand écran
    if (window.innerWidth > 768) { // Condition pour les écrans d'ordinateur
      event.preventDefault();
      setIsPhoneNumberExpanded(prevState => !prevState); // Inverse l'état d'expansion
    }
    // Sur mobile, le comportement par défaut `tel:` est souhaité
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      {/* Conteneur pour le bouton téléphone, bas gauche */}
      <div className="phone-floating-container">
        {/* Ajout d'une classe conditionnelle pour l'expansion */}
        <a
          href={`tel:${phoneNumber.replace(/\s/g, '')}`}
          className={`floating-button phone-button ${isPhoneNumberExpanded ? 'expanded' : ''}`}
          onClick={handlePhoneClick}
        >
          <span className="phone-icon" aria-label="Appeler">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M6.62 10.79a15.05 15.05 0 006.59 6.59l2.2-2.2a1 1 0 011.11-.21c1.21.49 2.53.76 3.88.76a1 1 0 011 1v3.5a1 1 0 01-1 1C10.07 22 2 13.93 2 4.5A1 1 0 013 3.5h3.5a1 1 0 011 1c0 1.35.27 2.67.76 3.88a1 1 0 01-.21 1.11l-2.2 2.2z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>
          <span className="phone-number">{phoneNumber}</span>
        </a>
      </div>

      {/* Conteneur pour le bouton "Retour en haut", bas droite */}
      {showScrollToTop && (
        <div className="scroll-to-top-floating-container">
          <button onClick={scrollToTop} className="floating-button scroll-to-top-button" aria-label="Retour en haut de la page">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 19V5M12 5L5 12M12 5l7 7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </div>
      )}
    </>
  );
}

export default FloatingButtons;